type ProductsFailureMap<R> = {
  serverFailure: () => R;
  networkFailure: () => R;
  productNotFoundFailure: () => R;
  categoryNotFoundFailure: () => R;
};

type ProductsFailureMaybeMap<R> = {
  serverFailure?: () => R;
  networkFailure?: () => R;
  productNotFoundFailure?: () => R;
  categoryNotFoundFailure?: () => R;
  orElse: () => R;
};

abstract class _ProductsFailure extends Error {
  public abstract map<R>(callbacks: ProductsFailureMap<R>): R;
  public abstract maybeMap<R>(callbacks: ProductsFailureMaybeMap<R>): R;
}

class ServerFailure extends _ProductsFailure {
  constructor() {
    super("ServerFailure");
  }

  public map<R>(callbacks: ProductsFailureMap<R>): R {
    return callbacks.serverFailure();
  }

  public maybeMap<R>(callbacks: ProductsFailureMaybeMap<R>): R {
    if (callbacks.serverFailure) return callbacks.serverFailure();
    return callbacks.orElse();
  }
}

class NetworkFailure extends _ProductsFailure {
  constructor() {
    super("NetworkFailure");
  }

  public map<R>(callbacks: ProductsFailureMap<R>): R {
    return callbacks.networkFailure();
  }

  public maybeMap<R>(callbacks: ProductsFailureMaybeMap<R>): R {
    if (callbacks.networkFailure) return callbacks.networkFailure();
    return callbacks.orElse();
  }
}

class ProductNotFoundFailure extends _ProductsFailure {
  constructor() {
    super("ProductNotFoundFailure");
  }

  public map<R>(callbacks: ProductsFailureMap<R>): R {
    return callbacks.productNotFoundFailure();
  }

  public maybeMap<R>(callbacks: ProductsFailureMaybeMap<R>): R {
    if (callbacks.productNotFoundFailure)
      return callbacks.productNotFoundFailure();
    return callbacks.orElse();
  }
}

class CategoryNotFoundFailure extends _ProductsFailure {
  constructor() {
    super("CategoryNotFoundFailure");
  }

  public map<R>(callbacks: ProductsFailureMap<R>): R {
    return callbacks.categoryNotFoundFailure();
  }

  public maybeMap<R>(callbacks: ProductsFailureMaybeMap<R>): R {
    if (callbacks.categoryNotFoundFailure)
      return callbacks.categoryNotFoundFailure();
    return callbacks.orElse();
  }
}

export type ProductsFailure = ServerFailure | NetworkFailure;

export const ProductsFailure = {
  serverFailure: () => new ServerFailure(),
  networkFailure: () => new NetworkFailure(),
  productNotFoundFailure: () => new ProductNotFoundFailure(),
  categoryNotFoundFailure: () => new CategoryNotFoundFailure(),
};
